import { LoginEvent } from '@typesApp/AppEvent'
import { logger } from '@utils/logger'

const KEY_EVENTS = 'direct-billing.events'

type LocalEventType = 'onLogin'

type LocalEventState = {
  type?: LocalEventType
  isHandled?: boolean
}

const saveToStorage = (state: LocalEventState) => {
  try {
    sessionStorage.setItem(KEY_EVENTS, JSON.stringify(state))
  } catch (error) {
    logger.warn('Error saving local event', error)
  }
}

export const pushLocalAppEvent = (event: LoginEvent) => {
  if (event?.type === 'onLogin') {
    saveToStorage({ type: 'onLogin' })
  }
}

export const setLocalEventHandled = (eventType: LocalEventType) => {
  const { type } = getLocalAppEventState()
  if (type === eventType) {
    saveToStorage({ type: eventType, isHandled: true })
  }
}

export const getLocalAppEventState = (): LocalEventState => {
  try {
    const value = sessionStorage.getItem(KEY_EVENTS)
    if (value) {
      const result = JSON.parse(value)
      return result && typeof result === 'object' ? result : {}
    }
    return {}
  } catch (e) {
    logger.error(e)
    return {}
  }
}

export const clearLocalAppEventState = () => {
  sessionStorage.removeItem(KEY_EVENTS)
}
